export default {
  'audit.review.subTitle': '审核系统中待处理的审核记录，包括：物业费、水费、电费、网费、停车费等各类费用审核',
  'audit.review.headerTitle': '待审核列表',
  'audit.review.column.auditNo': '审核单编号',
  'audit.review.column.billPeriod': '账期',
  'audit.review.column.auditName': '审核单名称',
  'audit.review.column.feeType': '费用类型',
  'audit.review.column.totalCount': '明细总数',
  'audit.review.column.totalAmount': '申请金额',
  'audit.review.column.status': '审核状态',
  'audit.review.column.submitterName': '提交人',
  'audit.review.column.submitTime': '提交时间',
  'audit.review.column.action': '操作',
  'audit.review.action.audit': '审核',
  'audit.review.action.auditTooltip': '进入审核',
  'audit.review.error.loadFeeTypes': '加载费用类型字典失败',
  'audit.review.error.loadApproveStatus': '加载审核状态字典失败',
  'audit.review.error.getList': '获取审核列表失败',
  'audit.review.confirm.delete': '确定要删除这条审核记录吗？',
  'audit.review.confirm.batchDelete': '确定要删除选中的审核记录吗？',
  'audit.review.status.unknown': '未知',
  'audit.review.feeType.mixed': '混合类型',
  'audit.review.drawer.title': '审核单详情',
  'audit.review.drawer.title.processing': '审核处理',
  'audit.review.drawer.title.detail': '审核详情',
  'audit.review.drawer.tag.dailyExpense': '日常花销',
  'audit.review.drawer.tag.budgetRequest': '预算申请',
  'audit.review.drawer.tag.mortgageRepayment': '房贷还款',
  'audit.review.drawer.tag.carLoanRepayment': '车贷还款',
  'audit.review.drawer.submittedAt': '申请于',
  'audit.review.drawer.submitted': '提交',
  'audit.review.drawer.section.relatedBankStatement': '关联银行账单',
  'audit.review.drawer.noBankStatement': '暂无关联银行账单',
  'audit.review.drawer.section.auditDecision': '审核决定',
  'audit.review.drawer.section.auditHistory': '流转动态',
  'audit.review.drawer.label.auditComment': '审核意见',
  'audit.review.drawer.placeholder.auditComment': '请输入您的审核意见...',
  'audit.review.drawer.button.reject': '拒绝',
  'audit.review.drawer.button.pass': '通过',
  'audit.review.drawer.button.cancel': '取消',
  'audit.review.drawer.button.editBill': '修改单据',
  'audit.review.drawer.button.followReview': '关注审核',
  'audit.review.drawer.button.unfollowReview': '取消关注',
  'audit.review.drawer.button.addComment': '信息添加有误',
  'audit.review.drawer.label.quickComments': '快捷备注',
  'audit.review.drawer.label.noAttachment': '暂无附件',
  'audit.review.drawer.timeline.submitted': '单据提交',
  'audit.review.drawer.timeline.pending': '等待中',
  'audit.review.drawer.timeline.completed': '已完成',
  'audit.review.drawer.timeline.financeAudit': '一级财务审核',
  'audit.review.drawer.timeline.propertyAudit': '一级物业审核',
  'audit.review.drawer.label.operator': '操作人',
  'audit.review.drawer.label.documentCode': '单据编号',
  'audit.review.drawer.label.accountingAmount': '核算金额',
  'audit.review.drawer.message.loadDetailFailed': '加载账单详情失败',
  'audit.review.drawer.message.approveSuccess': '审核通过',
  'audit.review.drawer.message.approveFailed': '审核失败',
  'audit.review.drawer.message.markedReviewLater': '已标记为关注审核',
  'audit.review.drawer.message.unmarkedReviewLater': '已取消关注审核',
  'audit.review.drawer.message.operationFailed': '操作失败',
  'audit.review.drawer.message.operationFailedRetry': '操作失败，请稍后重试',
  'audit.review.drawer.message.getBillDetailFailed': '获取单据详情失败',
  'audit.review.drawer.message.unsupportedBillEdit': '该类型单据暂不支持编辑',
  'audit.review.drawer.message.rejectReasonRequired': '请输入拒绝原因',
  'audit.review.drawer.message.rejectSuccess': '已拒绝',
  'audit.review.drawer.message.rejectFailed': '审核失败',
  'audit.review.drawer.tab.pending': '待审核',
  'audit.review.drawer.tab.approved': '已通过',
  'audit.review.drawer.tab.rejected': '已拒绝',
  'audit.review.drawer.column.houseInfo': '房屋信息',
  'audit.review.drawer.column.parkingInfo': '车位信息',
  'audit.review.drawer.column.name': '名称',
  'audit.review.drawer.column.billNo': '账单编号',
  'audit.review.drawer.column.status': '状态',
  'audit.review.drawer.column.amount': '应收金额',
  'audit.review.drawer.column.discountAmount': '优惠金额',
  'audit.review.drawer.column.lateFee': '滞纳金',
  'audit.review.drawer.column.finalAmount': '最终金额',
  'audit.review.drawer.column.ownerInfo': '业主信息',
  'audit.review.drawer.column.action': '操作',
  'audit.review.drawer.action.approve': '通过',
  'audit.review.drawer.action.reject': '拒绝',
  'audit.review.drawer.action.view': '查看',
  'audit.review.drawer.action.batchApprove': '批量通过',
  'audit.review.drawer.action.batchReject': '批量拒绝',
  'audit.review.drawer.info.period': '账期：',
  'audit.review.drawer.info.feeType': '费用类型：',
  'audit.review.drawer.info.status': '状态：',
  'audit.review.drawer.info.submitter': '提交人',
  'audit.review.drawer.info.submitTime': '提交时间',
  'audit.review.drawer.info.submitRemark': '提交说明',
  'audit.review.drawer.statistics.totalAmount': '总金额',
  'audit.review.drawer.statistics.pendingAmount': '待审核金额',
  'audit.review.drawer.statistics.approvedAmount': '已通过金额',
  'audit.review.drawer.statistics.rejectedAmount': '已拒绝金额',
  'audit.review.drawer.statistics.totalBills': '共 {count} 条账单',
  'audit.review.drawer.statistics.pendingBills': '{count} 条待处理',
  'audit.review.drawer.statistics.approvedBills': '{count} 条已通过',
  'audit.review.drawer.statistics.rejectedBills': '{count} 条已拒绝',
  'audit.review.drawer.pagination.total': '共 {total} 条',
  'audit.review.drawer.modal.approve.title': '审核确认',
  'audit.review.drawer.modal.approve.content': '确定要审核通过该账单吗？',
  'audit.review.drawer.modal.approve.billNo': '账单编号',
  'audit.review.drawer.modal.approve.amount': '应收金额',
  'audit.review.drawer.modal.approve.discountAmount': '优惠金额',
  'audit.review.drawer.modal.approve.lateFee': '滞纳金',
  'audit.review.drawer.modal.approve.finalAmount': '最终金额',
  'audit.review.drawer.modal.approve.okText': '确认通过',
  'audit.review.drawer.modal.approve.success': '审核通过：{billNo}',
  'audit.review.drawer.modal.approve.error': '审核失败，请重试',
  'audit.review.drawer.error.amountError': '金额填写错误',
  'audit.review.drawer.modal.reject.title': '审核拒绝',
  'audit.review.drawer.modal.reject.placeholder': '请输入拒绝原因（必填）',
  'audit.review.drawer.modal.reject.okText': '确认拒绝',
  'audit.review.drawer.modal.reject.error.reason': '请输入拒绝原因',
  'audit.review.drawer.modal.reject.success': '审核拒绝：{billNo}',
  'audit.review.drawer.modal.batchApprove.title': '批量审核确认',
  'audit.review.drawer.modal.batchApprove.content': '确定要批量审核通过选中的账单吗？',
  'audit.review.drawer.modal.batchApprove.count': '共 {count} 条账单将被审核通过',
  'audit.review.drawer.modal.batchApprove.summary': '金额汇总',
  'audit.review.drawer.modal.batchApprove.totalOriginal': '应收总额',
  'audit.review.drawer.modal.batchApprove.totalDiscount': '优惠总额',
  'audit.review.drawer.modal.batchApprove.totalLateFee': '滞纳金总额',
  'audit.review.drawer.modal.batchApprove.totalFinal': '最终总额',
  'audit.review.drawer.modal.batchApprove.okText': '确认批量通过',
  'audit.review.drawer.modal.batchApprove.success': '批量审核通过 {count} 条账单',
  'audit.review.drawer.modal.batchReject.title': '批量审核拒绝',
  'audit.review.drawer.modal.batchReject.content': '确定要批量拒绝选中的账单吗？',
  'audit.review.drawer.modal.batchReject.count': '共 {count} 条账单将被审核拒绝',
  'audit.review.drawer.modal.batchReject.reason': '拒绝原因（必填）',
  'audit.review.drawer.modal.batchReject.placeholder': '请详细说明拒绝原因，以便业主了解情况...',
  'audit.review.drawer.modal.batchReject.okText': '确认批量拒绝',
  'audit.review.drawer.modal.batchReject.success': '批量审核拒绝 {count} 条账单',
  'audit.review.drawer.error.selectBills': '请选择要审核的账单',
  'audit.review.drawer.error.loading': '数据加载中，请稍后再试',
  'audit.review.drawer.error.auditId': '审核单ID不存在',
  'audit.review.drawer.error.batchFailed': '批量审核失败，请重试',
  'audit.review.drawer.error.billIncomplete': '账单信息不完整',
  'audit.review.drawer.error.loadStatistics': '加载统计数据失败',
  'audit.review.drawer.error.loadData': '加载完整数据失败',
  'audit.review.drawer.error.getBillDetails': '获取账单明细失败',
  'audit.review.modal.property.title': '物业费账单详情',
  'audit.review.modal.parking.title': '停车费账单详情',
  'audit.review.modal.water.title': '水费账单详情',
  'audit.review.modal.electric.title': '电费账单详情',
  'audit.review.modal.network.title': '网费账单详情',
  'audit.review.modal.other.title': '其他费用账单详情',
  'audit.review.modal.default.title': '账单详情',
  'audit.review.modal.error.unknownFeeType': '未知的费用类型',
  'audit.review.modal.error.getDetailFailed': '获取账单详情失败',
  'audit.review.modal.section.basic': '基本信息',
  'audit.review.modal.section.houseOwner': '房屋与业主信息',
  'audit.review.modal.section.parkingOwner': '车位与业主信息',
  'audit.review.modal.section.amount': '金额信息',
  'audit.review.modal.section.payment': '缴费信息',
  'audit.review.modal.section.system': '系统信息',
  'audit.review.modal.section.meter': '抄表信息',
  'audit.review.modal.section.audit': '审核记录',
  'audit.review.modal.label.billNo': '账单编号',
  'audit.review.modal.label.period': '账期',
  'audit.review.modal.label.startTime': '开始时间',
  'audit.review.modal.label.endTime': '结束时间',
  'audit.review.modal.label.status': '缴费状态',
  'audit.review.modal.label.houseInfo': '房屋信息',
  'audit.review.modal.label.parkingInfo': '车位信息',
  'audit.review.modal.label.ownerInfo': '业主信息',
  'audit.review.modal.label.propertyFee': '物业费',
  'audit.review.modal.label.maintenanceFee': '维修基金',
  'audit.review.modal.label.otherFee': '其他费用',
  'audit.review.modal.label.lateFee': '滞纳金',
  'audit.review.modal.label.discountAmount': '优惠金额',
  'audit.review.modal.label.finalAmount': '应缴总金额',
  'audit.review.modal.label.paymentMethod': '支付方式',
  'audit.review.modal.label.paymentReference': '支付凭证号',
  'audit.review.modal.label.dueDate': '到期日期',
  'audit.review.modal.label.paidDate': '缴费日期',
  'audit.review.modal.label.createdTime': '创建时间',
  'audit.review.modal.label.updatedTime': '更新时间',
  'audit.review.modal.label.remarks': '备注',
  'audit.review.modal.label.waterUsage': '用水量',
  'audit.review.modal.label.elecUsage': '用电量',
  'audit.review.modal.label.lastReading': '上期读数',
  'audit.review.modal.label.lastReadingDate': '上期抄表时间',
  'audit.review.modal.label.currentReading': '本期读数',
  'audit.review.modal.label.currentReadingDate': '本期抄表时间',
  'audit.review.modal.label.unitPrice': '单价',
  'audit.review.modal.label.amount': '基础金额',
  'audit.review.modal.label.billName': '账单名称',
  'audit.review.modal.label.feeAmount': '费用金额',
  'audit.review.modal.label.parkingAmount': '停车费金额',
  'audit.review.modal.label.networkAmount': '网费金额',
  'audit.review.modal.label.finalPayAmount': '最终应付金额',
  'audit.review.modal.status.unpaid': '未缴费',
  'audit.review.modal.status.paid': '已缴费',
  'audit.review.modal.status.overdue': '逾期',
  'audit.review.modal.status.partial': '部分缴费',
  'audit.review.modal.status.cancelled': '已取消',
  'audit.review.modal.audit.loading': '加载中...',
  'audit.review.modal.audit.empty': '暂无审核记录',
  'audit.review.modal.unit.ton': '吨',
  'audit.review.modal.unit.degree': '度',
  'audit.review.modal.unit.yuanPerTon': '元/吨',
  'audit.review.modal.unit.yuanPerDegree': '元/度',
  'audit.review.feeType.property': '物业费',
  'audit.review.feeType.parking': '停车费',
  'audit.review.feeType.water': '水费',
  'audit.review.feeType.electric': '电费',
  'audit.review.feeType.network': '网费',
  'audit.review.feeType.other': '其他',
  'audit.review.status.pending': '待审核',
  'audit.review.status.approved': '已通过',
  'audit.review.status.rejected': '已拒绝',
  'audit.review.status.draft': '草稿',
  'audit.review.drawer.placeholder.discountAmount': '优惠金额',
  'audit.review.drawer.placeholder.lateFee': '滞纳金',
  'audit.review.drawer.unit.floor': '楼',
  'audit.review.drawer.unit.room': '室',
  'audit.review.modal.label.idCard': '身份证',
  'audit.review.modal.label.email': '邮箱',
  'audit.review.modal.label.ownerIdLabel': '业主ID',
  'audit.review.modal.error.getAuditRecordsFailed': '获取审核记录失败',
  'audit.review.modal.label.lastReadingWithUnit': '上期读数',
  'audit.review.modal.label.currentReadingWithUnit': '本期读数',
  'audit.review.modal.financialExpense.title': '财务花销详情',
  'audit.review.modal.budgetRequest.title': '预算申请详情',
  'audit.review.modal.mortgageRepayment.title': '房贷还款详情',
  'audit.review.modal.carRepayment.title': '车贷还款详情',
  'audit.review.modal.financialExpense.label.code': '编号',
  'audit.review.modal.financialExpense.label.name': '花销名称',
  'audit.review.modal.financialExpense.label.type': '花销类型',
  'audit.review.modal.financialExpense.label.amount': '金额',
  'audit.review.modal.financialExpense.label.applicantBy': '申请人ID',
  'audit.review.modal.financialExpense.label.applyReason': '申请说明',
  'audit.review.modal.financialExpense.label.auditBy': '审核人ID',
  'audit.review.modal.financialExpense.label.auditReason': '审核说明',
  'audit.review.modal.financialExpense.label.relatedFile': '相关文件',
  'audit.review.modal.label.documentName': '单据名称',
  'audit.review.modal.label.expenseType': '花销类型',
  'audit.review.modal.label.amountType': '收支类型',
  'audit.review.modal.label.amountType.income': '收入',
  'audit.review.modal.label.amountType.expense': '支出',
  'audit.review.modal.label.applicant': '申请人',
  'audit.review.modal.label.payee': '收款人',
  'audit.review.modal.label.projectName': '项目名称',
  'audit.review.modal.label.applicationReason': '申请事由',
  'audit.review.modal.label.submitRemark': '提交备注',
  'audit.review.modal.label.voucherMaterial': '凭证材料',
  'audit.review.modal.label.downloadFile': '下载文件',
  'audit.review.modal.label.statementNo': '账单编号',
  'audit.review.modal.label.billingPeriod': '账期',
  'audit.review.modal.label.bank': '银行',
  'audit.review.modal.label.totalIncome': '总收入',
  'audit.review.modal.label.totalExpense': '总支出',
  'audit.review.modal.label.auditName': '审核单名称',
  'audit.review.modal.budgetRequest.label.code': '预算申请编号',
  'audit.review.modal.budgetRequest.label.name': '预算申请名称',
  'audit.review.modal.budgetRequest.label.billingPeriod': '账期',
  'audit.review.modal.budgetRequest.label.amount': '申请金额',
  'audit.review.modal.budgetRequest.label.applyRemark': '申请备注',
  'audit.review.modal.budgetRequest.label.attachment': '附件文件',
  'audit.review.modal.common.label.status': '状态',
  'audit.review.modal.common.label.downloadFile': '下载文件',
  'audit.review.modal.common.label.fileFormat': '文件格式：',
  'audit.review.modal.common.label.fileSize': '文件大小：',
  'audit.review.modal.common.unknown': '未知',
  'audit.review.modal.status.draft': '草稿',
  'audit.review.modal.status.pending': '待审批',
  'audit.review.modal.status.approved': '已通过',
  'audit.review.modal.status.rejected': '已拒绝',
  'audit.reviewed.subTitle': '已完成审核的记录，包括：已通过、已拒绝等各类费用审核结果',
  'audit.reviewed.headerTitle': '已审核列表',
  'audit.reviewed.column.approvedAmount': '审核金额',
  'audit.reviewed.column.approverName': '审核人',
  'audit.reviewed.column.approveTime': '审核时间',
  'audit.reviewed.action.view': '查看',
  'audit.reviewed.action.viewTooltip': '查看详情',
  'audit.reviewed.error.loadFeeTypes': '加载费用类型字典失败',
  'audit.reviewed.error.loadApproveStatus': '加载审核状态字典失败',
  'audit.reviewed.error.getList': '获取审核列表失败',
  'audit.financeReview.subTitle': '审核系统中待处理的财务审核记录，包括：财务花销、预算申请等各类财务审核',
  'audit.financeReview.headerTitle': '财务待审核列表',
  'audit.financeReviewed.subTitle': '已完成审核的财务记录，包括：已通过、已拒绝等各类财务审核结果',
  'audit.financeReviewed.headerTitle': '财务已审核列表',
  'audit.financeReviewed.search.page.subTitle': '查看已审核的财务记录',
  'audit.financeReviewed.search.table.headerTitle': '财务审核查询',
  'audit.financeReviewed.search.action.batchAudit': '批量审核 ({count})',
  'audit.financeReviewed.search.message.selectRecordsFirst': '请先选择要审核的记录',

  'audit.review.drawer.label.ewtAmount': 'EWT 金额',
  'audit.review.drawer.label.ctoAmount': 'CTO 税金额',
  'audit.review.drawer.label.checkNo': '支票号',
  'audit.review.drawer.section.configAuditInfo': '配置审核信息',
  'audit.review.drawer.label.relatedBankStatement': '关联银行账单',
  'audit.review.drawer.placeholder.selectBankStatement': '请选择银行账单',
  'audit.review.drawer.button.setDefault': '设为默认',
  'audit.review.drawer.label.expenseType': '费用类型',
  'audit.review.drawer.placeholder.selectExpenseType': '请选择费用类型',
  'audit.review.drawer.placeholder.inputCheckNo': '请输入支票号',
  // Approve Confirm Modal
  'audit.review.modal.bankStatement.label': '银行账单',
  'audit.review.modal.bankStatement.placeholder': '请选择银行账单',
  'audit.review.modal.bankStatement.required': '请选择银行账单',
  'audit.review.modal.bankStatement.allUseSame': '所有选中的账单将使用同一个银行账单',
  'audit.review.modal.error.loadCurrency': '加载币种字典失败',
  'audit.review.modal.error.loadBankStatement': '加载银行账单失败',

  // Bill Detail Modal - Payment Records
  'audit.review.modal.payment.title': '历史缴费记录',
  'audit.review.modal.payment.recordTitle': '缴费记录',
  'audit.review.modal.payment.lateFee': '滞纳金',
  'audit.review.modal.payment.discountAmount': '优惠金额',
  'audit.review.modal.payment.finalAmount': '应缴费总额',
  'audit.review.modal.payment.payAmount': '实际缴费金额',
  'audit.review.modal.payment.withholdingAmount': '代扣金额',
  'audit.review.modal.payment.addBalanceAmount': '充值金额',
  'audit.review.modal.payment.remainAmount': '剩余金额',
  'audit.review.modal.payment.status': '缴费状态',
  'audit.review.modal.payment.status.paid': '已支付',
  'audit.review.modal.payment.status.partialPaid': '部分支付',
  'audit.review.modal.payment.payMethod': '支付方式',
  'audit.review.modal.payment.outTxnNo': '支付凭证号',
  'audit.review.modal.payment.projectName': '项目名称',
  'audit.review.modal.payment.bankStatement': '关联银行账单',
  'audit.review.modal.payment.payTime': '支付时间',

  // Bill Detail Modal - Other Fee
  'audit.review.modal.other.section.basic': '基本信息',
  'audit.review.modal.other.label.billNo': '账单编号',
  'audit.review.modal.other.label.period': '账期',
  'audit.review.modal.other.label.status': '缴费状态',

  // Bill Detail Modal - Financial Expense
  'audit.review.modal.expense.label.amountType': '收支类型',
  'audit.review.modal.expense.amountType.in': '收入',
  'audit.review.modal.expense.amountType.out': '支出',
};

